module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Illustrations"
    }
  }, [_c('p', {
    staticClass: "fm-title1"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HMS "), _c('i', [_vm._v("Achilles")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rear Admiral Sydney Fremantle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The memorial in Bodo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Changuinola")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral Sir Dudley de Chair")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Orvieto")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Busta Voe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hillswick Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map showing the basic operating areas of the Northern Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Changuinola")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cedric")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("India")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Carmania")]), _vm._v(" sinking "), _c('i', [_vm._v("Cap Trafalgar")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dazzle painting")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7in guns")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Plates#fig_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bayano")]), _vm._v(", before and during the war")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4416a8bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_List_of_Illustrations.vue
// module id = 75
// module chunks = 0